import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportManagementEndpoint } from '../constants/transport-management-endpoint';
import { TransportManagementFilterName } from '../constants/transport-management.constant';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TransportManagementFiltersService {
  private readonly url = `${API_URL}${TransportManagementEndpoint.Base}${TransportManagementEndpoint.Filters}`;
  constructor(private http: WrapperHttpService) {}

  getTransportManagementFilters(): Observable<TransportManagementFilterName[]> {
    return this.http.withLoading().get<TransportManagementFilterName[]>(this.url);
  }

  updateTransportManagementFilters(
    filters: TransportManagementFilterName[],
  ): Observable<TransportManagementFilterName[]> {
    return this.http.withLoading().post<TransportManagementFilterName[]>(this.url, filters);
  }
}
